"use client";

import { Menu, Phone } from "lucide-react";
import { useEffect, useState } from "react";
import { Link } from "@/components/common/Link";
import { MenuProvider, useMenu } from "@/integrations/wordpress/WordPressMenuProvider";
import { NavigationMenu, NavigationMenuItem, NavigationMenuLink, NavigationMenuList } from "@/components/ui/navigation-menu";
import { Button } from "@/components/ui/button";
function HeaderMenuConsumer() {
  const {
    menuItems,
    loading
  } = useMenu();
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);
  if (loading) {
    return <div className="hidden md:flex gap-1">
        <div className="h-9 w-16 bg-muted-light-background animate-pulse rounded-md" />
        <div className="h-9 w-16 bg-muted-light-background animate-pulse rounded-md" />
        <div className="h-9 w-16 bg-muted-light-background animate-pulse rounded-md" />
      </div>;
  }
  return <>
      <NavigationMenu viewport={false} className="hidden md:flex">
        <NavigationMenuList>
          {menuItems.map((item, i) => <NavigationMenuItem key={item.id} data-index={i}>
              <NavigationMenuLink asChild>
                <Link to={item.href || "#"} className="relative px-4 py-2 text-sm font-medium text-foreground-light hover:text-accent transition-all duration-[var(--duration-fast)] ease-[var(--ease-smooth)] after:absolute after:bottom-0 after:left-0 after:right-0 after:h-0.5 after:bg-accent after:scale-x-0 hover:after:scale-x-100 after:transition-transform after:duration-[var(--duration-fast)] after:ease-[var(--ease-smooth)] after:origin-center">
                  {item.label}
                </Link>
              </NavigationMenuLink>
            </NavigationMenuItem>)}
        </NavigationMenuList>
      </NavigationMenu>

      <Button variant="ghost" size="icon" className="md:hidden text-foreground-light hover:text-accent hover:bg-accent-light transition-all duration-[var(--duration-fast)]" onClick={() => setMobileMenuOpen(!mobileMenuOpen)} aria-label="Toggle menu">
        <Menu className="size-5" />
      </Button>

      {mobileMenuOpen && <div className="absolute top-full left-0 right-0 bg-background/95 backdrop-blur-md border-t border-border shadow-medium md:hidden z-50">
          <nav className="flex flex-col p-4 gap-2">
            {menuItems.map((item, i) => <Link key={item.id} data-index={i} to={item.href || "#"} className="px-4 py-3 text-sm font-medium text-foreground-light hover:bg-accent-light hover:text-accent rounded-md transition-all duration-[var(--duration-fast)] ease-[var(--ease-smooth)]" onClick={() => setMobileMenuOpen(false)}>
                {item.label}
              </Link>)}
          </nav>
        </div>}
    </>;
}
export default function Header() {
  const [scrolled, setScrolled] = useState(false);
  useEffect(() => {
    const handleScroll = () => {
      setScrolled(window.scrollY > 20);
    };
    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);
  return <header className={`fixed top-0 left-0 right-0 z-50 transition-all duration-[var(--duration-medium)] ease-[var(--ease-smooth)] ${scrolled ? "bg-background/80 backdrop-blur-md shadow-medium" : "bg-background/60 backdrop-blur-sm"}`}>
      <div className="container mx-auto px-4">
        <div className="flex items-center justify-between h-16">
          <Link to="/HomePage" className="flex items-center">
            <img src="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1438489/img/sam_branding_marketing_logo.png" alt="Sam Branding & Marketing" className="h-7" />
          </Link>

          <MenuProvider menu_id="41" className="flex-1 flex justify-center">
            <HeaderMenuConsumer />
          </MenuProvider>

          <Link to="/ContactPage" aria-label="Contact us">
            <Button variant="ghost" size="icon" className="text-accent hover:text-accent-hover hover:bg-accent-light transition-all duration-[var(--duration-fast)] ease-[var(--ease-smooth)] focus-visible:ring-primary/40">
              <Phone className="size-5" />
            </Button>
          </Link>
        </div>
      </div>
    </header>;
}